import smoothscroll from 'smoothscroll-polyfill';
import axios from 'axios';
import debounce from 'lodash/debounce';
import checkUser from '../../../resources/scripts/helpers/check-user';

class BrixSelectedProducts {
  static init(...parameters) {
    return new BrixSelectedProducts(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.scrollWrapper = block.querySelector('.scroll-wrapper');
    this.posts = block.querySelector('.products');
    this.scrollLeftButton = block.querySelector('.scroll-button.-left');
    this.scrollRightButton = block.querySelector('.scroll-button.-right');
    this.images = block.querySelectorAll('.image-wrapper');
    this.imageElements = block.querySelectorAll('img');

    this.checkUser();
    this.lazyLoadImages();

    const { offset } = this.scrollWrapper.dataset;
    if (this.images[0]) {
      const imageWidth = this.images[0].clientWidth;

      this.scrollLeftButton.addEventListener('click', () => {
        let scrollDistance = window.innerWidth < 576 ? -imageWidth - 24 : -imageWidth - 40;

        scrollDistance *= offset;

        this.posts.scrollBy({
          top: 0,
          left: scrollDistance,
          behavior: 'smooth',
        });
      });

      this.scrollRightButton.addEventListener('click', () => {
        let scrollDistance = window.innerWidth < 576 ? imageWidth + 24 : imageWidth + 40;

        scrollDistance *= offset;

        this.posts.scrollBy({
          top: 0,
          left: scrollDistance,
          behavior: 'smooth',
        });
      });
    }

    smoothscroll.polyfill();

    this.toggleScrollControls();

    window.addEventListener('resize', debounce(() => { this.toggleScrollControls(); }, 50));
    this.posts.addEventListener('scroll', debounce(() => { this.toggleButtonVisibility(); }, 50));
  }

  lazyLoadImages() {
    const options = {
      rootMargin: '0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((elements) => {
      elements.forEach((element) => {
        if (element.isIntersecting && element.target.getAttribute('src') === '') {
          element.target.setAttribute('srcset', element.target.dataset.srcset);
          element.target.setAttribute('src', element.target.dataset.src);
          if (element.target.complete) {
            element.target.classList.add('-loaded');
          } else {
            element.target.addEventListener('load', () => {
              element.target.classList.add('-loaded');
            });
          }
        }
      });
    }, options);

    this.imageElements.forEach((image) => {
      observer.observe(image);
    });
  }

  toggleScrollControls() {
    if (this.posts && this.scrollWrapper) {
      if (this.posts.scrollWidth > this.scrollWrapper.offsetWidth) {
        this.toggleButtonVisibility();
      } else {
        this.scrollLeftButton.classList.add('-hide');
        this.scrollRightButton.classList.add('-hide');
      }
    }
  }

  toggleButtonVisibility() {
    this.scrollRightButton.classList.remove('-hide');

    // Show left scroll button
    if (this.posts.scrollLeft > 1 && this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollLeftButton.classList.remove('-hide');
    }

    // Hide left scroll button
    if (this.posts.scrollLeft < 1 && !this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollLeftButton.classList.add('-hide');
    }

    // Show right scroll button
    if (this.posts.scrollLeft > 1 && this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollRightButton.classList.remove('-hide');
    }

    // Show right scroll button
    if (this.posts.scrollLeft + this.posts.offsetWidth
      <= this.posts.scrollWidth && this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollRightButton.classList.remove('-hide');
    }

    // Hide right scroll button
    if (this.posts.scrollLeft + this.posts.offsetWidth
      >= this.posts.scrollWidth && !this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollRightButton.classList.add('-hide');
    }
  }

  checkUser() {
    const restUrl = document.querySelector('meta[name="rest-url"]').getAttribute('content');

    const products = this.posts.querySelectorAll('.product');

    const productIds = [...products].map((product) => product.dataset.productId);

    checkUser(
      () => {
        axios.get(`${restUrl}brix/v1/product/${productIds.toString()}`)
          .then((productsResponse) => {
            if (productsResponse.data) {
              products.forEach((product) => {
                const { productId } = product.dataset;

                const priceAmountWrapper = product.querySelector('.price-amount-wrapper');
                const productPriceEl = priceAmountWrapper.querySelector('.product-price');
                const productAmountEl = priceAmountWrapper.querySelector('.product-amount');
                const { formattedPrice, productAmount } = productsResponse.data[productId];

                productPriceEl.innerHTML = `${formattedPrice} ${productPriceEl.innerHTML}`;
                productAmountEl.innerHTML = `${productAmount} ${productAmountEl.innerHTML}`;

                priceAmountWrapper.classList.remove('-hidden');
              });
            }
          }).catch((e) => {
            console.log(`Error: ${e}`);
          });
      },
    );
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-selected-products', BrixSelectedProducts.init);
}
